import * as React from 'react';

// Inline (not an svgr .svg import) so the clipPath/filter ids stay unique.
// svgr minifies ids to a/b/c across every icon, which collides with other
// SVGs on the page — a foreign clipPath#a was clipping this orb to a rect.
function AiOrb(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      width="74"
      height="74"
      viewBox="0 0 74 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#aiOrbClip)">
        <g filter="url(#aiOrbBlur0)">
          <circle cx="44" cy="42" r="33" fill="#599BF5" />
        </g>
        <g filter="url(#aiOrbBlur1)">
          <circle cx="31" cy="33" r="30" fill="#5C34CD" />
        </g>
        <g filter="url(#aiOrbBlur2)">
          <circle cx="18" cy="30" r="30" fill="#9277DE" />
        </g>
        <g filter="url(#aiOrbBlur3)">
          <path
            d="M41.9405 29.6813C36.9169 40.9856 27.9348 47.9677 21.8785 45.2762C15.8222 42.5848 15.4998 31.5002 29.4996 26.9998C40.0706 16.5002 34.0143 1.6484 40.0706 4.33981C46.1269 7.03123 46.9641 18.377 41.9405 29.6813Z"
            fill="white"
            fillOpacity="0.5"
          />
        </g>
        <path
          d="M40.9521 27.8496L44.125 26.625L45.2939 23.5078C45.3496 23.2295 45.6279 23.0625 45.9062 23.0625C46.1289 23.0625 46.4072 23.2295 46.4629 23.5078L47.6875 26.625L50.8047 27.8496C51.083 27.9053 51.25 28.1836 51.25 28.4062C51.25 28.6846 51.083 28.9629 50.8047 29.0186L47.6875 30.1875L46.4629 33.3604C46.4072 33.583 46.1289 33.75 45.9062 33.75C45.6279 33.75 45.3496 33.583 45.2939 33.3604L44.125 30.1875L40.9521 29.0186C40.7295 28.9629 40.5625 28.6846 40.5625 28.4062C40.5625 28.1836 40.7295 27.9053 40.9521 27.8496ZM34.1611 27.1816L37.0557 33.5273L43.4014 36.4219C43.7354 36.5889 43.958 36.9229 43.958 37.2568C43.958 37.5908 43.7354 37.9248 43.4014 38.0361L37.0557 40.9863L34.1611 47.332C33.9941 47.666 33.6602 47.8887 33.3262 47.8887C32.9922 47.8887 32.6582 47.666 32.5469 47.332L29.5967 40.9863L23.251 38.0918C22.917 37.9248 22.75 37.5908 22.75 37.2568C22.75 36.9229 22.917 36.5889 23.251 36.4219L29.5967 33.5273L32.5469 27.1816C32.6582 26.8477 32.9922 26.625 33.3262 26.625C33.6602 26.625 33.9941 26.8477 34.1611 27.1816ZM44.125 44.4375L45.2939 41.3203C45.3496 41.042 45.6279 40.875 45.9062 40.875C46.1289 40.875 46.4072 41.042 46.4629 41.3203L47.6875 44.4375L50.8047 45.6621C51.083 45.7178 51.25 45.9961 51.25 46.2188C51.25 46.4971 51.083 46.7754 50.8047 46.8311L47.6875 48L46.4629 51.1729C46.4072 51.3955 46.1289 51.5625 45.9062 51.5625C45.6279 51.5625 45.3496 51.3955 45.2939 51.1729L44.125 48L40.9521 46.8311C40.7295 46.7754 40.5625 46.4971 40.5625 46.2188C40.5625 45.9961 40.7295 45.7178 40.9521 45.6621L44.125 44.4375Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="aiOrbBlur0"
          x="-10"
          y="-12"
          width="108"
          height="108"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="10.5" />
        </filter>
        <filter
          id="aiOrbBlur1"
          x="-20"
          y="-18"
          width="102"
          height="102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="10.5" />
        </filter>
        <filter
          id="aiOrbBlur2"
          x="-33"
          y="-21"
          width="102"
          height="102"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="10.5" />
        </filter>
        <filter
          id="aiOrbBlur3"
          x="1.91211"
          y="-11.9805"
          width="59.3103"
          height="73.8337"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceGraphic" stdDeviation="8" />
        </filter>
        <clipPath id="aiOrbClip">
          <rect x="7" y="7" width="60" height="60" rx="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AiOrb;
